module.exports = __webpack_public_path__ + "img/2a.2ab29056.jpg";